// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__XMdsc","default":"Button_default__e3o5q","white":"Button_white__r8eFt"};